import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const HistoricalRedux = createActions({},
  {
    prefix: 'HISTORICAL_',
    defaultActions: {
      get: true,
      getReset: true,
    },
  },
)

const { Types, Creators } = HistoricalRedux
export const HistoricalTypes = Types
export default Creators

export const INITIAL_STATE = createState({
}, {
  get: true,
})


export const reducer = createReducer(
  INITIAL_STATE, {},
  {
    defaultActions: {
      get: true,
      getReset: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/HistoricalRedux.js